// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__nnad8","Button":"styles_Button__A2iOZ"};